module.exports = __webpack_public_path__ + "576a442cd6ad7356b2d3030cee3144c8.png";